module.exports = __webpack_public_path__ + "img/cartel_camara_comercio.c526fe9b.png";